import styled from 'styled-components';
import { FontWeight } from 'commons';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 480px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.neutral_300};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .bold {
    font-weight: ${FontWeight.semiBold};
  }

  .danger {
    color: ${({ theme }) => theme.danger_300};
  }
`;
